import { render } from "./ClaimComponent.vue?vue&type=template&id=4fb7a428"
import script from "./ClaimComponent.vue?vue&type=script&lang=js"
export * from "./ClaimComponent.vue?vue&type=script&lang=js"

import "./ClaimComponent.vue?vue&type=style&index=0&id=4fb7a428&lang=scss"
script.render = render

export default script